document.addEventListener('DOMContentLoaded', function() {
    function reorderElements() {
        if (window.innerWidth <= 767) {
            const persons = document.querySelectorAll('.person');
            persons.forEach(person => {
                const name = person.querySelector('.person-name');
                const image = person.querySelector('.person-image');
                const bio = person.querySelector('.person-bio');
                let specialMob = person.querySelector('.special-mob');
                if (!specialMob) {
                    specialMob = document.createElement('div');
                    specialMob.className = 'special-mob';
                    if (name) specialMob.appendChild(name.cloneNode(true));
                    if (image) specialMob.appendChild(image.cloneNode(true));
                    if (name) name.remove();
                    if (image) image.remove();
                    person.insertBefore(specialMob, person.firstChild);
                }
            });
        }
    }
    reorderElements();
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(reorderElements, 250);
    });
}); 